import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { SearchCreditLinesListAction } from '../actions/financing.actions';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Constants } from '../util/constants';
import {PageableApiResult} from "../models/pagable-api-result.model";
import { SearchBillsListAction } from '../actions/bills.actions';
import { IBills, IBillsFilters } from '../models/bills.model';
import { BillingApiService } from '../api/billing-api.service';

export interface BillingStateModel {
  billsList: IBills[];
  billsPageableList: PageableApiResult<IBills>;
  billsFilters: IBillsFilters;
}

const initialState: BillingStateModel = {
  billsList: null,
  billsPageableList: null,
  billsFilters: null,
};

const BILLING_STATE_TOKEN = new StateToken<BillingStateModel>('billing');

@State<BillingStateModel>({
  name: BILLING_STATE_TOKEN,
  defaults: initialState,
})
@Injectable()
export class BillingState {
  constructor(private billingApiService: BillingApiService) {}

  @Action(SearchBillsListAction)
  handleSearchBillsListAction(ctx: StateContext<BillingStateModel>, action: SearchBillsListAction) {
    const filter = ctx.getState()?.billsFilters;
    const actionFilter = action.payload.filter;
    console.log('filtro', actionFilter)
    let reqFilter: IBillsFilters;
    if (filter || actionFilter) {
      reqFilter = {
        ...filter,
        ...actionFilter,
      };
    } else {
      reqFilter = {
        page: 0,
        size: 10,
        documentType: null,
        documentNumber: null,
        createdDateMin: null,
        createdDateMax: null,
        operations: null,
        sortByCreatedDate: 'ASC',
      };
    }
    ctx.patchState({
      billsFilters: reqFilter,
    });

    return this.billingApiService.getBillsList(reqFilter).pipe(
      tap((lineas) => {
        ctx.patchState({
          billsList: lineas.content,
          billsPageableList: lineas,
        });
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  @Selector()
  static getCreditLinesList(state: BillingStateModel) {
    return state?.billsPageableList;
  }
}
